export enum TipoAcceso{
    AccesoNormal = 1,
    AccesoManagement = 2,
    AccesoExterno = 3
    
}


// WEBPACK FOOTER //
// /app/src/app/shared/enumeration/tipo-acceso.enum.ts